import React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';

const containerVariants = cva('w-full mx-auto', {
  variants: {
    // narrow = forms/settings, wide = standard detail pages,
    // ultrawide = dense data pages (folders, bookings) that need the room
    // on large monitors, full = no cap.
    width: {
      narrow: 'max-w-3xl',
      wide: 'max-w-7xl',
      ultrawide: 'max-w-screen-2xl',
      full: '',
    },
  },
  defaultVariants: {
    width: 'wide',
  },
});

const paddingVariants = cva('', {
  variants: {
    padding: {
      none: '',
      sm: 'px-4 sm:px-6 py-4',
      md: 'px-4 sm:px-6 lg:px-8 py-6',
    },
  },
  defaultVariants: {
    padding: 'md',
  },
});

type KoobContainerProps = {
  children: React.ReactNode;
} & VariantProps<typeof containerVariants> &
  VariantProps<typeof paddingVariants>;

// Page gutter + max-width cap. Padding lives on the outer element so the
// centered content keeps its full max-width on large screens.
const KoobContainer = React.forwardRef<HTMLDivElement, KoobContainerProps>(
  ({ width, padding, children }, ref) => (
    <div ref={ref} className={paddingVariants({ padding })}>
      <div className={containerVariants({ width })}>{children}</div>
    </div>
  ),
);

KoobContainer.displayName = 'KoobContainer';

export default KoobContainer;
